var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { Translate } from "../../../I18N";
import { InputError } from "./InputError";
import { Label } from "./Label";





















const Textarea = ({
  id,
  label,
  disabled,
  hideLabel,
  placeholder,
  hasErrors,
  errorMessage,
  value,
  className = '',
  name = '',
  ref,
  clearFieldAction,
  onChange = () => {},
  onSelect = () => {},
  onBlur = () => {},
  resize = 'none',
  rows = 4
}) => {
  let fieldStyles = 'border-gray-300 border text-gray-900 focus:ring-primary-500 bg-gray-50';
  let clearFieldStyles = 'enabled:hover:text-primary-700 text-gray-900';

  if (hasErrors || errorMessage) {
    fieldStyles =
    'border-error-300 focus:border-error-500 focus:ring-error-500 border-2 text-error-900 bg-error-50 placeholder-error-700';
    clearFieldStyles = 'enabled:hover:text-error-700 text-error-900';
  }

  if (clearFieldAction) {
    fieldStyles = `${fieldStyles} pr-10`;
  }

  return (/*#__PURE__*/
    _jsx("div", { className: className }, void 0, /*#__PURE__*/
    _jsx(Label, {
      htmlFor: id,
      hideLabel: !label || hideLabel,
      hasErrors: Boolean(hasErrors || errorMessage) }, void 0,

    label
    ), /*#__PURE__*/
    _jsx("div", { className: "relative flex w-full" }, void 0, /*#__PURE__*/
    React.createElement("textarea", {
      id: id,
      onSelect: onSelect,
      onChange: onChange,
      onBlur: onBlur,
      name: name,
      ref: ref,
      disabled: disabled,
      value: value,
      className: `${fieldStyles} disabled:text-gray-500 block flex-1 w-full text-sm rounded`,
      rows: rows,
      placeholder: placeholder,
      style: { resize } }
    ),
    Boolean(clearFieldAction) && /*#__PURE__*/
    _jsx("button", {
      type: "button",
      onClick: clearFieldAction,
      disabled: disabled,
      "data-testid": "clear-field-button",
      className: `${clearFieldStyles} top-px disabled:text-gray-500 absolute p-2.5 right-0 text-sm font-medium rounded-r-lg
             focus:outline-none` }, void 0, /*#__PURE__*/

    _jsx(XMarkIcon, { className: "w-5" }), /*#__PURE__*/
    _jsx(Translate, { className: "sr-only" }, void 0, "Clear")
    )

    ),
    errorMessage && /*#__PURE__*/_jsx(InputError, {}, void 0, errorMessage)
    ));

};


export { Textarea };